export default {
  GET_INSPECTOR_ANCILLARY_SERVICE_DATATABLE: 'GET_INSPECTOR_ANCILLARY_SERVICE_DATATABLE'
}
